import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import BackgroundFx from "./BackgroundFx";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="relative min-h-screen text-mgfc-fg">
      <BackgroundFx />
      <NavBar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <div className="vignette" aria-hidden />
      <div className="scanlines" aria-hidden />
    </div>
  );
}
